module.exports = __webpack_public_path__ + "fonts/memSYaGs126MiZpBA-UvWbX2vVnXBbObj2OVZyOOSr4dVJWUgshZ1x4saVIGxA.fe3583f.woff2";